import { inject, Injectable } from "@angular/core";
import { TranslationService } from "../translation/translation.service";
import {
  BackInterface,
  ProductInterface,
} from "../../interface/menu.interface";
import { BehaviorSubject } from "rxjs";
import { AuthService } from "../auth/auth.service";

@Injectable({
  providedIn: "root",
})
export class MenuService {
  constructor() {}
  translationService = inject(TranslationService);
  private authService = inject(AuthService);
  public productSubject: BehaviorSubject<ProductInterface[]> =
    new BehaviorSubject<ProductInterface[]>([]);

  public backSubject: BehaviorSubject<BackInterface> =
    new BehaviorSubject<BackInterface>(null);

  initialiseProducts() {
    const products: ProductInterface[] = [
      {
        id: "saleko",
        name: this.translationService.t("INST.web.saleko"),
        icon: "assets/side-bar-icons/1. Dashboard Icon.svg",
        menus: [
          {
            id: "saleko.dashboard",
            name: this.translationService.t("saleko.dashboard"),
            route: "/dashboard",
            icon: "assets/side-bar-icons/1. Dashboard Icon.svg",
            active: false,
            menus: [],
            moduleSlug: "dashboard_analytics",
          },
          {
            id: "saleko.myMerchant",
            name: this.translationService.t("saleko.myMerchant"),
            route: "/MyMerchant",
            icon: "assets/side-bar-icons/2. Operations Icon.svg",
            active: false,
            moduleSlug: "operations",
            menus: [
              {
                id: "saleko.pickUp",
                name: this.translationService.t("saleko.pickUp"),
                route: "/MyMerchant/pick-up-hub",
                icon: "assets/icons/menus/in-pickup.svg",
                active: false,
                menus: [],
              },
              // {
              //   id: 'saleko.representatives',
              //   name: this.translationService.t('saleko.representatives'),
              //   route: '/MyMerchant/representatives',
              //   icon: 'assets/icons/menus/representatives.svg',
              //   active: false,
              //   menus: [],
              // },
              {
                id: "saleko.markets",
                name: this.translationService.t("saleko.markets"),
                route: "/MyMerchant/markets",
                icon: "assets/icons/menus/in-markets.svg",
                active: false,
                menus: [],
              },
              {
                id: "saleko.productRequests",
                name: this.translationService.t("saleko.productRequests"),
                route: "/MyMerchant/product-requests",
                icon: "assets/icons/menus/in-product-requests.svg",
                active: false,
                menus: [],
              },

              // {
              //   id: 'saleko.categoryCommission',
              //   name: this.translationService.t('saleko.categoryCommission'),
              //   route: '/MyMerchant/category-commission',
              //   icon: 'assets/icons/menus/in-category-commission.svg',
              //   active: false,
              //   menus: [],
              // },
            ],
          },
          // {
          //   id: 'saleko.marketPlace',
          //   name: this.translationService.t('saleko.marketPlace'),
          //   route: '/marketplace',
          //   icon: 'assets/side-bar-icons/3. Market Place.svg',
          //   active: false,
          //   menus: [
          //     // {
          //     //   id: 'saleko.sellers',
          //     //   name: this.translationService.t('saleko.sellers'),
          //     //   route: '/marketplace/sellers',
          //     //   icon: 'assets/icons/menus/in-sellers.svg',
          //     //   active: false,
          //     //   menus: [],
          //     // },
          //     {
          //       id: 'saleko.sellersRev',
          //       name: this.translationService.t('saleko.sellersRev'),
          //       route: '/marketplace/sellers-review',
          //       icon: 'assets/icons/menus/in-sellers.svg',
          //       active: false,
          //       menus: [],
          //     },
          //     {
          //       id: 'saleko.negotiation',
          //       name: this.translationService.t('saleko.negotiation'),
          //       route: '/marketplace/negotiation',
          //       icon: 'assets/icons/menus/in-sellers.svg',
          //       active: false,
          //       menus: [],
          //     },
          //     {
          //       id: 'saleko.flagReason',
          //       name: this.translationService.t('saleko.flagReason'),
          //       route: '/marketplace/flag-reason',
          //       icon: 'assets/icons/menus/in-sellers.svg',
          //       active: false,
          //       menus: [],
          //     },
          //   ],
          // },
          {
            id: "saleko.sales",
            name: this.translationService.t("saleko.sales"),
            route: "/sales",
            icon: "assets/side-bar-icons/4. Sales.svg",
            active: false,
            moduleSlug: "order_management",
            menus: [
              {
                id: "saleko.orders",
                name: this.translationService.t("saleko.orders"),
                route: "sales",
                icon: "assets/icons/menus/in-sellers.svg",
                active: false,
                menus: [],
              },
              // {
              //   id: 'saleko.orderAccnt',
              //   name: this.translationService.t('saleko.orderAccnt'),
              //   route: '/sales/orders-accounting',
              //   icon: 'assets/icons/menus/in-sellers.svg',
              //   active: false,
              //   menus: [],
              // },
              {
                id: "saleko.refunds",
                name: this.translationService.t("saleko.refunds"),
                route: "/sales/sales-refunds",
                icon: "assets/icons/menus/in-sellers.svg",
                active: false,
                menus: [],
              },
            ],
          },
          {
            id: "saleko.catalogue",
            name: this.translationService.t("saleko.catalogue"),
            route: "/catelog",
            icon: "assets/side-bar-icons/5. Catalogue.svg",
            active: false,
            moduleSlug: "product_catalog",
            menus: [
              {
                id: "saleko.product",
                name: this.translationService.t("saleko.product"),
                route: "/catelog/product",
                icon: "",
                active: false,
                menus: [],
              },
              {
                id: "saleko.category",
                name: this.translationService.t("saleko.category"),
                route: "/catelog/category",
                icon: "assets/icons/menus/in-catelog.svg",
                active: false,
                menus: [],
              },
              {
                id: "saleko.attributes",
                name: this.translationService.t("saleko.attributes"),
                route: "/catelog/attributes",
                icon: "assets/icons/menus/in-catelog.svg",
                active: false,
                menus: [],
              },
              // {
              //   id: 'saleko.attributesFamily',
              //   name: this.translationService.t('saleko.attributesFamily'),
              //   route: '/catelog/attributes-family',
              //   icon: 'assets/icons/menus/in-catelog.svg',
              //   active: false,
              //   menus: [],
              // },
            ],
          },
          {
            id: "saleko.users",
            name: this.translationService.t("saleko.users"),
            route: "/users",
            icon: "assets/side-bar-icons/6. Users.svg",
            active: false,
            moduleSlug: "user_management",
            menus: [
              {
                id: "saleko.customers",
                name: this.translationService.t("saleko.customers"),
                route: "/users/customers",
                icon: "assets/icons/menus/in-users.svg",
                active: false,
                menus: [],
                moduleSlug: "user_management",
              },
              {
                id: "saleko.merchants",
                name: this.translationService.t("saleko.merchants"),
                route: "/users/merchants",
                icon: "assets/icons/menus/in-users.svg",
                active: false,
                menus: [],
                moduleSlug: "seller_management",
              },
              {
                id: "saleko.staffs",
                name: this.translationService.t("saleko.staffs"),
                route: "/users/staffs",
                icon: "assets/icons/menus/in-users.svg",
                active: false,
                menus: [],
                moduleSlug: "system_configuration",
              },
              {
                id: "saleko.rolesPermissions",
                name: this.translationService.t("saleko.rolesPermissions"),
                route: "/users/roles-permissions",
                icon: "assets/icons/menus/in-users.svg",
                active: false,
                menus: [],
                moduleSlug: "system_configuration",
              },
              // {
              //   id: 'saleko.auditLog',
              //   name: this.translationService.t('saleko.auditLog'),
              //   route: '/users/audit-log',
              //   icon: 'assets/icons/menus/in-users.svg',
              //   active: false,
              //   menus: [],
              // },
            ],
          },
          // TAG SERVICE
          {
            id: "saleko.tagService",
            name: this.translationService.t("saleko.tagService"),
            route: "/tag-service",
            icon: "assets/side-bar-icons/tagServiceIcon.svg",
            active: false,
            moduleSlug: "tag_management",
            menus: [
              // {
              //   id: "saleko.promotions",
              //   name: this.translationService.t("saleko.promotions"),
              //   route: "/marketing/promotions",
              //   icon: "assets/icons/menus/in-promotions.svg",
              //   active: false,
              // },
            ],
          },
          // MarketPlace Here
          {
            id: "saleko.marketing",
            name: this.translationService.t("saleko.marketing"),
            route: "/marketing",
            icon: "assets/side-bar-icons/8. Marketing.svg",
            active: false,
            moduleSlug: "promotions_content",
            menus: [
              {
                id: "saleko.promotions",
                name: this.translationService.t("saleko.promotions"),
                route: "/marketing/promotions",
                icon: "assets/icons/menus/in-promotions.svg",
                active: false,
                menus: [
                  {
                    id: "promotions.flashSales",
                    name: this.translationService.t("saleko.promotions"),
                    route: "/marketing/flash-sales",
                    icon: "",
                    active: false,
                    menus: [],
                  },
                  {
                    id: "promotions.addFlashSales",
                    name: this.translationService.t("saleko.promotions"),
                    route: "/marketing/add-flash-sales",
                    icon: "",
                    active: false,
                    menus: [],
                  },
                  {
                    id: "promotions.seasonal",
                    name: this.translationService.t("saleko.promotions"),
                    route: "/marketing/seasonal-c-b",
                    icon: "",
                    active: false,
                    menus: [],
                  },
                  {
                    id: "promotions.addSeasonal",
                    name: this.translationService.t("saleko.promotions"),
                    route: "/marketing/add-seasonal-c-b",
                    icon: "",
                    active: false,
                    menus: [],
                  },
                  {
                    id: "promotions.buyGetFree",
                    name: this.translationService.t("saleko.promotions"),
                    route: "/marketing/buy-get-free",
                    icon: "",
                    active: false,
                    menus: [],
                  },
                  {
                    id: "promotions.addBuyGetFree",
                    name: this.translationService.t("saleko.promotions"),
                    route: "/marketing/add-buy-get-free",
                    icon: "",
                    active: false,
                    menus: [],
                  },
                  {
                    id: "promotions.coupons",
                    name: this.translationService.t("saleko.promotions"),
                    route: "/marketing/discount-coupons-promo-codes",
                    icon: "",
                    active: false,
                    menus: [],
                  },
                  {
                    id: "promotions.addCoupons",
                    name: this.translationService.t("saleko.promotions"),
                    route: "/marketing/add-discount-coupons-promo-codes",
                    icon: "",
                    active: false,
                    menus: [],
                  },
                ],
              },
               {
                id: 'saleko.banner',
                name: this.translationService.t('saleko.banner'),
                route: '/marketing/banner',
                icon: 'assets/icons/menus/in-promotions.svg',
                active: false,
                menus: [],
              },

              // {
              //   id: 'saleko.outreachEngagement',
              //   name: this.translationService.t('saleko.outreachEngagement'),
              //   route: '/marketing/outreach-engagement',
              //   icon: 'assets/icons/menus/in-promotions.svg',
              //   active: false,
              //   menus: [],
              // },
              // {
              //   id: 'saleko.campaigns',
              //   name: this.translationService.t('saleko.campaigns'),
              //   route: '/marketing/campaigns',
              //   icon: 'assets/icons/menus/in-campaigns.svg',
              //   active: false,
              //   menus: [],
              // },
            ],
          },
          // PayQart Here
          {
            id: "saleko.payqart",
            name: this.translationService.t("saleko.payqart"),
            route: "/payqart",
            icon: "assets/side-bar-icons/Payqart_logo[1] 2.svg",
            hoverIcon: "assets/side-bar-icons/Payqart_logo[1] 2 hover.svg",
            active: false,
            moduleSlug: "payqart",
            menus: [
              {
                id: "saleko.overview",
                name: this.translationService.t("saleko.overview"),
                route: "/payqart/payqart-overview",
                icon: "",
                active: false,
                menus: [],
              },
              {
                id: "saleko.payqartMgt",
                name: this.translationService.t("saleko.payqartMgt"),
                route: "/payqart/payqart-mgt",
                icon: "assets/icons/menus/in-catelog.svg",
                active: false,
                menus: [],
              },
              {
                id: "saleko.repaymentMgt",
                name: this.translationService.t("saleko.repaymentMgt"),
                route: "/payqart/repayment-mgt",
                icon: "assets/icons/menus/in-catelog.svg",
                active: false,
                menus: [],
              },
              {
                id: "saleko.disbursementMgt",
                name: this.translationService.t("saleko.disbursementMgt"),
                route: "/payqart/disbursement-mgt",
                icon: "assets/icons/menus/in-catelog.svg",
                active: false,
                menus: [],
              },
              {
                id: "saleko.companies",
                name: this.translationService.t("saleko.companies"),
                route: "/payqart/companies",
                icon: "",
                active: false,
                menus: [],
              },
              {
                id: "saleko.staffandPayroll",
                name: this.translationService.t("saleko.staffandPayroll"),
                route: "/payqart/staff-and-payroll",
                icon: "",
                active: false,
                menus: [],
              },
              {
                id: "saleko.payrollUpload",
                name: this.translationService.t("saleko.payrollUpload"),
                route: "/payqart/payroll-upload",
                icon: "",
                active: false,
                menus: [],
              },

             { id: "saleko.settings",
                name: this.translationService.t("saleko.settings"),
                route: "/payqart/settings",
                icon: "assets/icons/menus/in-catelog.svg",
                active: false,
                menus: [],
              },

              // {
              //   id: 'saleko.attributesFamily',
              //   name: this.translationService.t('saleko.attributesFamily'),
              //   route: '/catelog/attributes-family',
              //   icon: 'assets/icons/menus/in-catelog.svg',
              //   active: false,
              //   menus: [],
              // },
            ],
          },

          // fleetmangement
          {
            id: "saleko.fleetManagement",
            name: this.translationService.t("saleko.fleetManagement"),
            route: "/fleet-management",
            icon: "assets/side-bar-icons/10. Fleet Management.svg",
            hoverIcon: "assets/side-bar-icons/fleet-management hover.svg",
            disableActiveColoring: true,
            active: false,
            moduleSlug: "fleet",
            menus: [
              {
                id: "saleko.riderManagement",
                name: this.translationService.t("saleko.riderManagement"),
                route: "/fleet-management/rider-management",
                icon: "",
                active: false,
                menus: [],
              },
              {
                id: "saleko.order",
                name: this.translationService.t("saleko.order"),
                route: "/fleet-management/order",
                icon: "",
                active: false,
                menus: [],
              },
              {
                id: "saleko.paymentOnDelivery",
                name: this.translationService.t("saleko.paymentOnDelivery"),
                route: "/fleet-management/payment-on-delivery",
                icon: "",
                active: false,
                menus: [],
              },
            ],
          },
          // {
          //   id: 'saleko.escrow',
          //   name: this.translationService.t('saleko.escrow'),
          //   route: '/escrow',
          //   icon: 'assets/side-bar-icons/7. Escrow.svg',
          //   active: false,
          //   menus: [],
          // },

          // {
          //   id: 'saleko.salekoHubs',
          //   name: this.translationService.t('saleko.salekoHubs'),
          //   route: '/hubs',
          //   icon: 'assets/side-bar-icons/9. Hub.svg',
          //   active: false,
          //   menus: [],
          // },
          // {
          //   id: 'saleko.accountSettings',
          //   name: this.translationService.t('saleko.accountSettings'),
          //   route: '/account-settings',
          //   icon: 'assets/icons/menus/in-account-settings.svg',
          //   active: false,
          //   menus: [],
          // },
          // {
          //   id: 'saleko.customers',
          //   name: this.translationService.t('saleko.customers'),
          //   route: '/customers',
          //   icon: 'assets/icons/menus/in-customers.svg',
          //   active: false,
          //   menus: [],
          // },
          // {
          //   id: 'saleko.sellers',
          //   name: this.translationService.t('saleko.sellers'),
          //   route: '/sellers',
          //   icon: 'assets/icons/menus/in-sellers.svg',
          //   active: false,
          //   menus: [],
          // },
          // {
          //   id: 'saleko.inventory',
          //   name: this.translationService.t('saleko.inventory'),
          //   route: '/inventory',
          //   icon: 'assets/icons/menus/in-inventory.svg',
          //   active: false,
          //   menus: [],
          // },
          // {
          //   id: 'saleko.pricingAndCommission',
          //   name: this.translationService.t('saleko.pricingAndCommission'),
          //   route: '/pricing-commission',
          //   icon: 'assets/icons/menus/in-pricing-commission.svg',
          //   active: false,
          //   menus: [],
          // },
          // {
          //   id: 'saleko.fleetManagement',
          //   name: this.translationService.t('saleko.fleetManagement'),
          //   route: '/fleet-management',
          //   icon: 'assets/icons/menus/in-fleet-management.svg',
          //   active: false,
          //   menus: [],
          // },
          // {
          //   id: 'saleko.tasks',
          //   name: this.translationService.t('saleko.tasks'),
          //   route: '/tasks',
          //   icon: 'assets/icons/menus/in-tasks.svg',
          //   active: false,
          //   menus: [],
          // },
        ],
      },
    ];
    this.productSubject.next(this.filterByAccess(products));
  }

  private hasAccess(item: {
    moduleSlug?: string;
    permission?: string;
  }): boolean {
    if (item.permission) return this.authService.hasPermission(item.permission);
    if (item.moduleSlug)
      return this.authService.hasModuleAccess(item.moduleSlug);
    return true;
  }

  private filterByAccess(products: ProductInterface[]): ProductInterface[] {
    if (this.authService.isSuperAdmin()) return products;

    return products.map((product) => ({
      ...product,
      menus: (product.menus ?? [])
        .filter((item) => {
          const parentAccessible = this.hasAccess(item);
          if (item.menus && item.menus.length > 0) {
            // Only children that carry their own access requirement count toward unlocking the parent
            const gatedChildren = item.menus.filter(
              (child) =>
                (child.moduleSlug || child.permission) && this.hasAccess(child),
            );
            return parentAccessible || gatedChildren.length > 0;
          }
          return parentAccessible;
        })
        .map((item) => {
          const parentAccessible = this.hasAccess(item);
          return {
            ...item,
            // Ungated children (no moduleSlug/permission) follow their parent's access
            menus: (item.menus ?? []).filter((child) =>
              child.moduleSlug || child.permission
                ? this.hasAccess(child)
                : parentAccessible,
            ),
          };
        }),
    }));
  }

  ifBackActive(data: BackInterface) {
    this.backSubject.next(data);
  }
}
